import { useEffect, useRef } from "react";
import { toast } from "sonner";

// Écran racine d'une PWA Android : 1er Retour → toast, 2e Retour (< 2 s) → on laisse le système quitter.
// Une seule entrée « sentinelle » est ajoutée (pas de boucle pushState) ; le 2e appui recule réellement dans l'historique.
export function useExitOnDoubleBack(isRoot) {
  const armed = useRef(0);
  useEffect(() => {
    if (!isRoot) return;
    if (!window.history.state?.sanitdocsRoot) window.history.pushState({ sanitdocsRoot: true }, "");
    const onPop = () => {
      if (Date.now() - armed.current < 2000) { armed.current = 0; window.history.back(); return; }
      armed.current = Date.now();
      toast("Appuyez de nouveau pour quitter", { duration: 1800 });
      window.history.pushState({ sanitdocsRoot: true }, "");
    };
    window.addEventListener("popstate", onPop);
    return () => window.removeEventListener("popstate", onPop);
  }, [isRoot]);
}
